import httpService from "./http.service";

class ColorCategoriesService {
  getColorCategoriesUrl = "/color/category";

  getColorCategories = () => {
    return httpService.get(this.getColorCategoriesUrl);
  };
  createColorCategory = (model) => {
    return httpService.post(this.getColorCategoriesUrl, model, "createColor");
  };
  editColorCategory = (id, model) => {
    return httpService.patch(this.getColorCategoriesUrl + "/" + id, model, "editColor", {}, "patch");
  };    
  deleteColorCategory = (id) => {
    return httpService.delete(this.getColorCategoriesUrl + "/" + id);
  };
  setColorToCategories = (categoryId, colorIds) => {
    return httpService.post(this.getColorCategoriesUrl + "/set-color/" + categoryId, colorIds);
  }
}

const colorCategoriesService = new ColorCategoriesService();
export default colorCategoriesService;
